import {useQuery} from '@aboutyou/data-fetcher';
import {MissionSuccessNotification} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/mission.types';
import {useCallback} from 'react';

const getNotificationKey = (
  missionSuccessNotification: MissionSuccessNotification,
) =>
  `${missionSuccessNotification.missionIdentifier.missionId}:${missionSuccessNotification.missionIdentifier.tierIndex}`;

export const useSuccessMissionState = () => {
  const {data, updateCache} = useQuery<{
    missionSuccessNotification?: MissionSuccessNotification;
    // Position of the desktop header button in the success mission popup.
    openerPosition?: {top: number};
    // For most of the missions, the SuccessMissionPopup should appear only after the toast has been displayed.
    shouldBeShownAfterToast?: boolean;
  }>(
    'success-mission-state',
    () => ({
      missionSuccessNotification: undefined,
      openerPosition: undefined,
      shouldBeShownAfterToast: true,
    }),
    {
      keepPreviousData: false,
    },
  );

  const setMissionSuccessNotification = useCallback(
    ({
      missionSuccessNotification,
      shouldBeShownAfterToast,
      expectedNotificationKey,
    }: {
      missionSuccessNotification: MissionSuccessNotification | undefined;
      shouldBeShownAfterToast?: boolean;
      expectedNotificationKey?: string;
    }) => {
      updateCache(oldData => {
        if (
          expectedNotificationKey &&
          oldData?.missionSuccessNotification &&
          getNotificationKey(oldData.missionSuccessNotification) !==
            expectedNotificationKey
        ) {
          return oldData;
        }

        return {
          ...oldData,
          missionSuccessNotification,
          shouldBeShownAfterToast: shouldBeShownAfterToast ?? true,
        };
      });
    },
    [updateCache],
  );

  const setOpenerPosition = useCallback(
    (position: {top: number}) => {
      updateCache(oldData => ({
        ...oldData,
        openerPosition: {top: position.top},
      }));
    },
    [updateCache],
  );

  return {
    missionSuccessNotification: data?.missionSuccessNotification,
    shouldBeShownAfterToast: data?.shouldBeShownAfterToast,
    setMissionSuccessNotification,
    openerPosition: data?.openerPosition,
    setOpenerPosition,
  };
};
